import React from "react";
import { Modal } from "@mui/material";
import LoadingPlaceHolder from "./loading-placeholder";

interface LoadingModalProps {
  open: boolean;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ open, message }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="loading-modal"
      aria-describedby="loading-indicator"
    >
      <div className="flex items-center justify-center h-screen w-screen">
        <LoadingPlaceHolder
          message={message}
          animate={open}
        ></LoadingPlaceHolder>
      </div>
    </Modal>
  );
};

export default LoadingModal;
